<div class="dialogue-content" *ngIf="!IsPreview">
    <div class="mat-dialogue-header">
      <h4 class="mat-dialog-title previewHeading" id="modal-basic-title">{{TooltipName}} Tooltip</h4>
      <button type="button" class="btn-close" aria-label="Close" [mat-dialog-close]="false"></button>
    </div>
    <mat-dialog-content class="editor-tooltip">
        <ckeditor  [editor]="Editor" [config]="editorConfig" [(ngModel)]="q_1"  ></ckeditor>
    </mat-dialog-content>
    <div mat-dialog-actions class="dialog-actions dialogue-footer text-center mb-3" >
      <button class="btn btn-secondary" [mat-dialog-close]="true" (click)="saveTooltip()" >Save</button>
      <button class="btn btn-primary" [mat-dialog-close]="false">Cancel</button>
    </div>
</div>

<div class="dialogue-content" *ngIf="IsPreview">
  <div class="mat-dialogue-header">
    <h4 class="mat-dialog-title previewHeading" id="modal-basic-title">{{TooltipName}} Tooltip</h4>
    <button type="button" class="btn-close" aria-label="Close" [mat-dialog-close]="false"></button>
  </div>
  <mat-dialog-content class="editor-tooltip">
    <ng-container *ngIf="q_1 != null && q_1 != ''">
      <div class="hover-inner-content" [innerHTML]="q_1"></div>
    </ng-container>
    <ng-container *ngIf="q_1 == null || q_1 == ''">
      <div class="d-flex justify-content-center">No Tooltip Found.</div>
    </ng-container>

  </mat-dialog-content>
</div>
